import { EventStatusFromAPI } from "@api/routers/events";

export const getTailwindColorFromEventStatus = (eventStatus: EventStatusFromAPI | undefined) => {
  switch (eventStatus) {
    case "live":
      return {
        borderColor: "border-red-500",
        textColor: "text-red-500",
      };
    case "on break":
      return {
        borderColor: "border-orange-400",
        textColor: "text-orange-400",
      };
    case "starting":
      return {
        borderColor: "border-orange-400",
        textColor: "text-orange-400",
      };
    case "new":
      return {
        borderColor: "border-blue-500",
        textColor: "text-blue-500",
      };
    case "available":
      return {
        borderColor: "border-blue-500",
        textColor: "text-blue-500",
      };
    case "published":
      return {
        borderColor: "border-green-600",
        textColor: "text-green-600",
      };
    default:
      return {
        borderColor: "border-gray-500",
        textColor: "text-gray-500",
      };
  }
};
